import { Routes } from "@angular/router";
import { DirtyGuard } from "~app/common/guards/dirty.guard";
import { RaskRoller } from "~app/common/models/constants";
import { AnvandareComponent } from "~app/features/administration/anvandare/anvandare.component";
import { CertifikatComponent } from "~app/features/administration/certifikat/certifikat.component";
import { JobbDetailsComponent } from "~app/features/administration/jobb/jobb-details/jobb-details.component";
import { JobbComponent } from "~app/features/administration/jobb/jobb.component";
import { KontraktsmigreringComponent } from "~app/features/administration/kontraktsmigrering/kontraktsmigrering.component";
import { MattslagskonverteringComponent } from "~app/features/administration/mattslagskonvertering/mattslagskonvertering.component";
import { OvervakningComponent } from "~app/features/administration/overvakning/overvakning.component";
import { ProduktionsomradeComponent } from "~app/features/administration/produktionsomrade/produktionsomrade.component";
import { RebusMessagesComponent } from "~app/features/administration/rebus/rebus-messages/rebus-messages.component";
import { RebusComponent } from "~app/features/administration/rebus/rebus.component";
import { RegelverkViol3Component } from "~app/features/administration/regelverk-viol3/regelverk-viol3.component";
import { SortimentComponent } from "~app/features/administration/sortiment/sortiment.component";
import { SystemadministrationComponent } from "~app/features/administration/systemadministration/systemadministration.component";
import { SystemaktivitetComponent } from "~app/features/administration/systemaktivitet/systemaktivitet.component";
import { VikariehanteringComponent } from "~app/features/administration/vikariehantering/vikariehantering.component";

export const administrationRoutes: Routes = [
    {
        path: "administration",
        children: [
            {
                path: "anvandare",
                title: "Användare",
                component: AnvandareComponent,
                canDeactivate: [DirtyGuard],
                data: {
                    requiredRoles: [RaskRoller.role.Administrera],
                    editRoles: [RaskRoller.role.Administrera]
                }
            },
            {
                path: "sortiment",
                title: "Sortiment",
                component: SortimentComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [
                        RaskRoller.role.Administrera,
                        RaskRoller.role.Produktadministrera
                    ]
                }
            },
            {
                path: "certifikat",
                title: "Certifikat",
                component: CertifikatComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Certifikatsadministrera],
                    editRoles: [RaskRoller.role.Certifikatsadministrera]
                }
            },
            {
                path: "kontraktsmigrering",
                title: "Kontraktsmigrering",
                component: KontraktsmigreringComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Virkesekonomiadministrera],
                    editRoles: [RaskRoller.role.Virkesekonomiadministrera]
                }
            },
            {
                path: "produktionsomrade",
                component: ProduktionsomradeComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Produktinstruktionsadmininstrera]
                }
            },
            {
                path: "vikariehantering",
                component: VikariehanteringComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Administrera],
                    editRoles: [RaskRoller.role.Administrera]
                }
            }
        ]
    },
    {
        path: "mattslagskonvertering",
        title: "Måttslagskonvertering",
        component: MattslagskonverteringComponent,
        canDeactivate: [DirtyGuard],
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Kundhantera]
        }
    },
    {
        path: "systemaktivitet",
        title: "Systemaktivitet",
        component: SystemaktivitetComponent,
        data: {
            requiredRoles: [],
            editRoles: [RaskRoller.role.Administrera]
        }
    },
    {
        path: "systemadministration",
        title: "Systemadministration",
        component: SystemadministrationComponent,
        canDeactivate: [DirtyGuard],
        data: {
            requiredRoles: [RaskRoller.role.Systemadministrera],
            editRoles: [RaskRoller.role.Systemadministrera]
        }
    },
    {
        path: "overvakning/:id",
        title: "Övervakning",
        component: OvervakningComponent,
        data: {
            requiredRoles: [RaskRoller.role.Systemadministrera],
            editRoles: [RaskRoller.role.Systemadministrera]
        }
    },
    {
        path: "overvakning",
        redirectTo: "overvakning/",
        pathMatch: "full"
    },
    {
        path: "jobb",
        title: "Jobb",
        children: [
            {
                path: "",
                component: JobbComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Systemadministrera],
                    editRoles: [RaskRoller.role.Systemadministrera],
                    volatileState: "jobb"
                }
            },
            {
                path: ":typ/:status",
                component: JobbDetailsComponent,
                title: "Jobb detaljer",
                data: {
                    requiredRoles: [RaskRoller.role.Systemadministrera],
                    editRoles: [RaskRoller.role.Systemadministrera],
                    volatileState: "jobb"
                }
            }
        ]
    },
    {
        path: "rebus",
        title: "Rebus",
        children: [
            {
                path: "",
                component: RebusComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Systemadministrera],
                    editRoles: [RaskRoller.role.Systemadministrera]
                }
            },
            {
                path: ":type/:queue",
                title: "Rebus messages",
                component: RebusMessagesComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Systemadministrera],
                    editRoles: [RaskRoller.role.Systemadministrera]
                }
            },
            {
                path: ":type/:queue/:subQueue",
                title: "Rebus messages",
                component: RebusMessagesComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Systemadministrera],
                    editRoles: [RaskRoller.role.Systemadministrera]
                }
            }
        ]
    },
    {
        path: "regelverkviol3",
        title: "Regelverk",
        component: RegelverkViol3Component,
        data: {
            requiredRoles: [RaskRoller.role.Titta],
            editRoles: [RaskRoller.role.Produktadministrera]
        }
    }
];
